// Round badge used to mark how good a move was (analysis)
const MoveBadge = ({size = 20, color, label, star = false}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" role="img" aria-hidden="true">
        <circle cx="12" cy="12" r="11" fill={color} stroke="#fff" strokeWidth="1.6"/>
        {star ? (
            <path d="M12 5.6l1.9 3.9 4.3.6-3.1 3 .7 4.3L12 15.4l-3.8 2 .7-4.3-3.1-3 4.3-.6z" fill="#fff"/>
        ) : (
            <text x="12" y="12.5" textAnchor="middle" dominantBaseline="middle" fill="#fff"
                  fontFamily="Nunito Variable, Nunito, Arial, sans-serif" fontWeight="900"
                  fontSize={label.length > 1 ? 10 : 13}>{label}</text>
        )}
    </svg>
);

export default MoveBadge;
